import { setNewPassword } from '../../../data/repositories/authRepository.js';

export const resetPassword = (contactNumber, password) => setNewPassword(contactNumber, password);
